import React from 'react';
import { observer } from 'mobx-react';
import { WeaSelect } from 'ecCom';

@observer
export default class SelectNew extends React.Component<any, any>{

    onChange = (v) => {
        const {onChange,detailtype,multiple} = this.props;
        onChange(v,detailtype, multiple);
    }

    render() {
        return <WeaSelect ecId={`${this && this.props && this.props.ecId || ''}_WeaSelect@o7u2t1`} 
            {...this.props}
            onChange={this.onChange}
        ></WeaSelect>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/commonComs/selectNew.tsx